import { Injectable } from '@angular/core';
import { ActivatedRoute, CanActivate } from '@angular/router';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RedirectToV2Guard implements CanActivate {

  constructor(private activatedRoute: ActivatedRoute) { }

  canActivate(): boolean {
    if (environment.redirectToV2) {
      const currentEndpoint = window.location.pathname
      const currentQuery = this.activatedRoute.snapshot.queryParams

      const queryString = new URLSearchParams(currentQuery as any).toString()
      window.location.href = `${environment.redirectToV2}${currentEndpoint}${queryString ? `?${queryString}` : ''}`

      return false;
    }
    return true;
  }
} 